import * as React from 'react';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export default function Calendar() {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<React.Fragment>
			<span className='animate-pulse inline-block text-[#B83855]'> <CalendarMonthIcon /> </span> <Link onClick={handleClickOpen} style={{ color: 'inherit' }} component="button" title="Fishing charters availability in cabo san lucas | Goin' Fission">
				Check Availability
			</Link>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				maxWidth="lg" // This makes the dialog wider (options: 'xs', 'sm', 'md', 'lg', 'xl', false)
				fullWidth // This makes the dialog take full width according to maxWidth
			>
				<DialogTitle id="alert-dialog-title">
					{"Goin Fission Booking Availability"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description" sx={{ width: '100%' }}>
						<iframe
							src="https://calendar.google.com/calendar/embed?src=bookings%40goinfissioncabo.com&ctz=America%2FPhoenix"
							style={{
								border: 0,
								width: '100%',
								minHeight: '800px'
							}}
							frameBorder="0"
							scrolling="no"
							title='Google Calendar'
						/>
					</DialogContentText>
				</DialogContent>
			</Dialog>
		</React.Fragment>
	);
}